import { get } from 'lodash';
import store from '@/store/index';
import { isInrCurrency } from '@/utils/currency';
import { plansof } from '@/utils/chain';
import { couponTypes } from '../../coupon/helper/constant';

export const checkIsShowInrDiscount = (plan) => {
  const { couponState = {}, getSubscriptions = [] } = store.getters;
  const { plan_code } = plan ?? {};
  const isNotCouponDiscount = couponState?.couponType === couponTypes.NO_DISCOUNT;
  const PRO_ANNUAL_PLAN_CODE = 'zo_pro_yearly';
  const isProAnnualPlan = plan_code === PRO_ANNUAL_PLAN_CODE;
  const { inrProDiscountFeatureEnable, enableInrProDiscount } = getInrProAnnualCustomPriceConfig();
  // If the user has pro annual pro, backend subscription has already given the discount value.
  // In this case, we shouldn't apply the 10% discount
  const isSubscriptionContainsProAnnual = getSubscriptions?.some((plan) => plan.plan_code === PRO_ANNUAL_PLAN_CODE);
  return (
    !isSubscriptionContainsProAnnual &&
    isProAnnualPlan &&
    isInrCurrency() &&
    enableInrProDiscount &&
    inrProDiscountFeatureEnable &&
    isNotCouponDiscount
  );
};

export const getInrProAnnualCustomPriceConfig = () => {
  return get(window, 'newBillingConfig.inrProAnnualCustomPriceConfig', {});
};

export const getInrDiscountAmount = () => {
  const { getSelectedPlans } = store.getters;
  const inrProAnnualCustomPriceConfig = getInrProAnnualCustomPriceConfig();
  const proAnnualPlan = plansof(getSelectedPlans).code(inrProAnnualCustomPriceConfig?.targetPlanCode)?.plans?.[0];
  const isShowInrDiscount = checkIsShowInrDiscount(proAnnualPlan);
  if (!isShowInrDiscount) {
    return 0;
  }
  const discount = inrProAnnualCustomPriceConfig.priceChangeRatio; // eg: -10
  const selectedNumber = proAnnualPlan?.cartInfo?.selected_number ?? 1;
  return (proAnnualPlan.amount * selectedNumber * discount) / 100; // negative value
};
